import { UserModel } from '$tablet-app/src/app/auth/UserModel';
import { getAvatar } from '$tablet-app/src/app/avatars/functions/getAvatar';
import { ListeningBars } from '$tablet-app/src/app/components/ListeningBars/ListeningBars';
import PegasusAvatar from '$tablet-app/src/app/components/Pegasus/PegasusAvatar';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import DashboardProfile from '$tablet-app/src/app/dashboard/DashboardProfile';
import { useGetStateVariable } from '$tablet-app/src/app/state_variables';
import { StateVariableNames } from '$tablet-app/src/app/state_variables/state_variable_names';
import { margin, palette } from '$tablet-app/src/app/theme';
import React from 'react';
import styled from 'styled-components/native';

interface Props {
  user?: UserModel;
  avatar_expression?: string;

  mic_active?: boolean;
}

const TRY_THESE = [
  { title: 'Calendar', message: '“Hey Pixi, open the calendar”' },
  { title: 'Your Schedule', message: "“Hey Pixi, what's next”" },
  { title: 'Alerts', message: 'Hey Pixi, add an alert for 5pm' },
];

const ChatScreenAvatarColumn = (props: Props) => {
  const {
    user,
    avatar_expression,

    mic_active = false,
  } = props;

  const { data: avatar_data } = useGetStateVariable(StateVariableNames.AVATAR);
  const avatar_asset = getAvatar(avatar_data);

  return (
    <LeftColumn>
      {user ? <DashboardProfile user={user} /> : null}

      <AvatarContainer>
        {avatar_asset ? (
          <AvatarImage source={avatar_asset} />
        ) : (
          <PegasusAvatar expression={avatar_expression} noEvents />
        )}
      </AvatarContainer>

      {mic_active ? (
        <Row justifyContent="center">
          <LoadingBarsContainer>
            <ListeningBars />

            <Text weight="semibold">Listening</Text>

            <Spacer height="16px" />
          </LoadingBarsContainer>
        </Row>
      ) : null}

      <Text bold preset="grey" style={margin(0, 0, 10)}>
        THINGS YOU CAN TRY
      </Text>

      <Suggestions>
        {TRY_THESE.map((msg) => (
          <Suggestion key={msg.title}>
            <Text bold>{msg.title}</Text>

            <Text italic>{msg.message}</Text>
          </Suggestion>
        ))}
      </Suggestions>
    </LeftColumn>
  );
};

const AvatarContainer = styled.View`
  height: 400px;
`;

const AvatarImage = styled.Image`
  height: 100%;
  width: 100%;
`;

const LeftColumn = styled.ScrollView`
  height: 100%;
  flex: 1;
  padding: 10px;
`;

const Suggestions = styled.View`
  gap: 10px;
`;

const Suggestion = styled.View`
  padding: 15px;
  background-color: ${palette.Background_blue};
  border-radius: 10px;
  gap: 10px;
`;

const LoadingBarsContainer = styled.View`
  align-items: center;

  gap: 8px;
`;

export default ChatScreenAvatarColumn;
